/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Check if two matches are equal
 */

import { RouteComponentProps } from 'react-router-dom'

import { MaybeRouteProps } from '../types'

type Match = MaybeRouteProps['match'] | RouteComponentProps['match']

export const matchesEqual = (match: Match, prevMatch: Match) => {
  return (
    match === prevMatch ||
    (!match && !prevMatch) ||
    (!!match && !!prevMatch && match.url === prevMatch.url)
  )
}
